import * as RadixSwitch from '@radix-ui/react-switch';
import { memo, type CSSProperties } from 'react';
import { classNames } from '~/utils/classNames';

interface SwitchProps {
  id?: string;
  className?: string;
  thumbClassName?: string;
  checked?: boolean;
  disabled?: boolean;
  onCheckedChange?: RadixSwitch.SwitchProps['onCheckedChange'];
  style?: CSSProperties;
  size?: 'sm' | 'md';
}

export const Switch = memo<SwitchProps>(
  ({ id, className, thumbClassName, checked, disabled, style, onCheckedChange, size = 'md' }) => {
    return (
      <RadixSwitch.Root
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={onCheckedChange}
        className={classNames(
          ' bg-gray-300 dark:bg-gray-800 rounded-full shrink-0 relative data-[state=checked]:bg-accent-600 dark:data-[state=checked]:bg-accent-600 outline-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed',
          { 'w-[44px] h-[25px]': size === 'md', 'w-9 h-5': size === 'sm' },
          className,
        )}
        style={{ WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', ...style }}
      >
        <RadixSwitch.Thumb
          className={classNames(
            'block bg-white dark:bg-gray-400 dark:data-[state=checked]:bg-white rounded-full shadow transition-transform duration-100 will-change-transform',
            {
              'w-[21px] h-[21px] translate-x-0.5 data-[state=checked]:translate-x-[21px]': size === 'md',
              'size-4 translate-x-1 data-[state=checked]:translate-x-[18px]': size === 'sm',
            },
            thumbClassName,
          )}
        />
      </RadixSwitch.Root>
    );
  },
);
